var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"type":"submit","variant":"success"},on:{"click":function($event){$event.stopPropagation();return _vm.click($event)}}},[_c('feather-icon',{attrs:{"icon":"SaveIcon"}}),_vm._v(" "+_vm._s(_vm.$t("general.save"))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }